// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup1":"ButtonGroup1_buttonGroup1__1l-f8","leftButton":"ButtonGroup1_leftButton__3NggT","rightButton":"ButtonGroup1_rightButton__3AdhV"};